import { module } from 'angular';
import { GmcSelectComponent2 } from './gmc-select2.component';
import { GmcSelectOptionComponent } from './components';

export const GmcSelectModule = module('app.shared.componentns.gmc-select-2', [])
  .component('gmcSelect2', GmcSelectComponent2)
  .component('gmcSelectOption', GmcSelectOptionComponent);



// WEBPACK FOOTER //
// ./app/shared/components/gmc-select-2/gmc-select-2.module.ts